import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Seccion from 'components/Modificaciones/Seccion'

import TopHeader from 'components/TopHeader'

function AcercaDe() {

	// render
	return (
		<Container fluid id="seccion2-2" className="vh-100">
			<TopHeader
				iconName="window-restore"
				text="Modificaciones sección Acerca de"
			/>
			<Row>
				<Col className="mt-2">
					<Seccion
						nombreSeccion="acerca-de"
					/>
				</Col>
			</Row>
		</Container>
	)
}

export default AcercaDe